import { AddCoverageDetails, TllCoverageStatus } from "@graphql/api";

import { createSearchParams } from "react-router-dom";

import { PROOF_OF_COVERAGE_ROUTES } from "@routing/Residents/ProofOfCoverage";
import { moveBackInPathname } from "@utils/moveBackInPathname";

export function addedCoverageRedirectPath(
  searchParams: URLSearchParams,
  pathname: string,
  data: AddCoverageDetails
) {
  if (
    !data.alreadyAddedCoverageId ||
    !data.alreadyAddedCoverageStatus ||
    [
      TllCoverageStatus.Cancelled,
      TllCoverageStatus.ScheduledCancellation,
    ].includes(data.alreadyAddedCoverageStatus)
  ) {
    return {
      pathname: `${moveBackInPathname(pathname, 2)}/${PROOF_OF_COVERAGE_ROUTES.COVERAGE_ADDED}`,
      search: createSearchParams(searchParams).toString(),
    };
  }

  if (data.alreadyAddedCoverageStatus === TllCoverageStatus.Active) {
    return {
      pathname: `${moveBackInPathname(pathname, 2)}/${PROOF_OF_COVERAGE_ROUTES.ACTIVE_TLL_FOUND}`,
      search: createSearchParams(searchParams).toString(),
    };
  }

  return {
    pathname: `${moveBackInPathname(pathname, 2)}/${PROOF_OF_COVERAGE_ROUTES.SCHEDULED_TLL_FOUND}`,
    search: createSearchParams(searchParams).toString(),
  };
}
